import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const CallToAction = () => {
  return (
    <section className="call-action-inner third index9">
      <div className="overlay pt-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-11 d-flex align-items-center justify-content-center">
              <div className="section-header text-center">
                <h3>Stop guessing what you actually earned.</h3>
                <p>
                  Layer tags, saved views, and scheduled exports on top of every
                  payout so your numbers stay audit-ready year round.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="bottom-area text-center">
                <p className="xxlr">OracleMarket analytics</p>
                <Link href={getDashboardPathUrl("/register")} className="cmn-btn">
                  Explore reports
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
